import { ColorModel } from '@tableau/color-and-border-models';
import * as React from 'react';
import { ButtonZoneImageStyle } from '../styles/ButtonZoneImageStyle';

export const TabButtonZoneSVGImageWrapperClass = 'tab-button-zone-SVG-image-wrapper';
export const TabButtonZoneImageClass = 'tab-button-zone-image';
export const TabButtonZoneImageOffLineAppender = '-offline';
export const TabButtonZoneImageComponentTestId = 'tab-button-zone-image-enabled-container';

export interface ButtonZoneImageProps {
  readonly imageUrl: string;
  readonly encodedImage: string;
  readonly encodedSVGImage: string;
  readonly imageHeight: number | string;
  readonly imageWidth: number | string;
  readonly backgroundColor: string;
  readonly hoverActive: boolean;
  readonly isButtonImageEnabled: boolean;
  readonly onImageLoadError?: () => void;
}

export class ButtonZoneImageComponent extends React.PureComponent<ButtonZoneImageProps> {
  public constructor(props: ButtonZoneImageProps) {
    super(props);
  }

  public render(): JSX.Element {
    if (this.props.isButtonImageEnabled) {
      return (
        <div className={ButtonZoneImageStyle.tabButtonZoneImageEnabledContainer} data-testid={TabButtonZoneImageComponentTestId}>
          {this.renderImageElement(TabButtonZoneImageClass)}
          {this.props.hoverActive ? this.renderButtonZoneImageHover() : null}
        </div>
      );
    } else {
      return this.renderImageElement(ButtonZoneImageStyle.tabButtonZoneImageDisabled);
    }
  }

  private renderImageElement(buttonImageClassName: string): JSX.Element {
    const imageWidth = this.props.imageWidth;
    const imageHeight = this.props.imageHeight;
    let imagePath = this.props.imageUrl;

    if (this.props.encodedImage.length > 0) {
      const offlineImageClassName = buttonImageClassName + TabButtonZoneImageOffLineAppender;
      return this.renderOfflineImage(imageWidth, imageHeight, offlineImageClassName);
    }

    if (this.props.encodedSVGImage.length > 0) {
      imagePath = 'data:image/svg+xml;base64,' + this.props.encodedSVGImage;
    }

    return this.createSVGWrapperForImage(imageWidth, imageHeight, imagePath, buttonImageClassName);
  }

  private renderOfflineImage(imageWidth: number | string, imageHeight: number | string, offlineImageClassName: string): JSX.Element {
    const imagePath = 'data:image/jpeg;base64,' + this.props.encodedImage;
    return <img className={offlineImageClassName} src={imagePath} width={imageWidth} height={imageHeight} alt={''} />;
  }

  private createSVGWrapperForImage(
    imageWidth: number | string,
    imageHeight: number | string,
    imagePath: string,
    buttonImageClassName: string
  ): JSX.Element {
    return (
      <svg className={TabButtonZoneSVGImageWrapperClass} width={imageWidth} height={imageHeight}>
        <defs>
          <filter id="grayscale">
            <feColorMatrix
              values="0.3333 0.3333 0.3333 0.4 0
                      0.3333 0.3333 0.3333 0.4 0
                      0.3333 0.3333 0.3333 0.4 0
                      0      0      0      1   0"
            />
          </filter>
        </defs>
        <image
          className={buttonImageClassName}
          href={imagePath}
          width={imageWidth}
          height={imageHeight}
          onError={this.props.onImageLoadError}
        />
      </svg>
    );
  }

  private renderButtonZoneImageHover(): JSX.Element {
    const hoverStyle: React.CSSProperties = {
      width: this.props.imageWidth,
      height: this.props.imageHeight,
      backgroundColor: ColorModel.fromColorCode(this.props.backgroundColor).toRGB(),
      opacity: 0.5,
    };

    return <div className={ButtonZoneImageStyle.tabButtonZoneImageHover} style={hoverStyle}></div>;
  }
}
